import { BaseService } from '@/api/services/BaseService';
import type { ApiEnvelope } from '@/api/errors';
import type { Subscription } from '@/types/priceAlert';

// Доступ к notification-manager: подписки на уведомления (группа PRICE_MONITORING — «лучшая цена»).
// GET читает подписки пользователя; POST /update принимает объект `{ subscriptions: [...] }`
// (UpdateSubscriptionRequest десериализуется как обычный record — @JsonValue влияет лишь на
// сериализацию, при чтении тела Jackson ждёт объект, а не голый массив); userId берётся из токена.
class SubscriptionService extends BaseService {
  /** Подписки пользователя на «лучшую цену продажи». Пустой список — норма (нет подписок). GET идемпотентен. */
  async getPriceAlerts(signal?: AbortSignal): Promise<Subscription[]> {
    const response = await this.request<ApiEnvelope<Subscription[]>>(
      { method: 'get', url: '/notifmanager/subscription', params: { messageGroup: 'PRICE_MONITORING' } },
      { idempotent: true, signal },
    );
    this.ensureSuccess(response.data, response.status);
    return response.data?.data ?? [];
  }

  /** Сохранить настройки каналов. Тело — массив подписок (по одной на канал). Мутация — без повтора. */
  async updatePriceAlerts(subscriptions: Subscription[]): Promise<void> {
    const response = await this.request<ApiEnvelope<void>>({
      method: 'post',
      url: '/notifmanager/subscription/update',
      data: { subscriptions },
    });
    this.ensureSuccess(response.data, response.status);
  }
}

export const subscriptionService = new SubscriptionService();
